<template>
  <div v-bind="$attrs" v-on="$listeners" class="excel-button d-flex align-items-center justify-content-center" :class="{'w-100': !!block}">
      <div class="mr-2"><img src="/img/excel.png" alt="" style="max-height: 16px;"></div>
      <slot></slot>
  </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        block: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>
.excel-button {
    cursor: pointer;
    border: 1px solid #1B7D35;
    border-radius: 5px;
    padding: 3px 5px;
    color: #FFFFFF;
    min-width: 28px;
    height: 28px;
    min-height: 28px;
    background-color: #238B39;
}
</style>
